<template>
    <v-text-field
            :value="value"
            :label="label"
            prefix="%"
            v-validate="validate"
            :loading="loading"
            type="number"
            readonly
            data-vv-name="descuento"
    >
        <v-menu slot="append-outer" :close-on-content-click="false" v-model="menu">
            <v-icon color="info" slot="activator">fa-edit</v-icon>
            <v-card>
                <v-card-text>
                    <v-checkbox v-if="!observar" label="¿Observar?" hide-details v-model="observar"></v-checkbox>
                    <v-textarea v-if="observar" label="Observaciones" v-model="obs"></v-textarea>
                    <v-list dense>
                        <v-subheader>Descuentos</v-subheader>
                        <template v-for="p in porcentajes">
                            <v-list-tile @click="porcentajeAsigna(p)">
                                <v-list-tile-action>
                                    <v-icon>{{ (porcent === p)? 'check_box':'check_box_outline_blank' }}</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    <v-list-tile-title>{{ p }}%</v-list-tile-title>
                                </v-list-tile-content>
                                <v-list-tile-action>{{ moneda }} {{ precio - ((precio / 100) * p) | moneda}}</v-list-tile-action>
                            </v-list-tile>
                        </template>
                    </v-list>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-layout class="text-xs-center">
                        <v-flex>
                            <v-btn icon flat color="red" @click.native="cerrar()">
                                <v-icon>clear</v-icon>
                            </v-btn>
                        </v-flex>
                        <v-flex>
                            <v-btn icon flat color="green" @click.native="precioConfirma()" :loading="loading">
                                <v-icon>done</v-icon>
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-menu>
    </v-text-field>
</template>
<script>
    import {mapActions} from 'vuex';
    import mixinPrecio from '../mixins/precios';
    import mixinConfig from '../mixins/config';
    import moneda from '../filters/moneda';

    export default {
        inject: ['$validator'],
        name: 'item-precio-unit',
        props: ['label', 'value', 'tipo', 'validate', 'moneda', 'producto', 'item','precio'],
        mixins: [mixinPrecio, mixinConfig],
        filters: {moneda},
        data() {
            return {
                loading: false,
                menu: false,
                valueNuevo: '',
                porcentajes: [],
                obs: '',
                observar: false,
                porcent: ''
            }
        },
        mounted() {
            this.configGet('porcentDes', r => {
                this.porcentajes = r;
            }, err => {
                console.error('Error al traer porcentajes')
            })
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            porcentajeAsigna(p) {
                this.valueNuevo = p;
                this.porcent = p;
            },
            actualizaValor() {
                this.$emit('input', this.valueNuevo);
                this.cerrar();
            },
            change(e) {
                this.$emit('change', e);
            },
            precioValida() {
                this.loading = true;
                this.precioEdicionValida(r => {
                    if (r.valida === true) {
                        this.menu = false;
                    } else {
                        this.msjShow({txt: 'No tiene los permisos necesarios para editar el precio', tipo: 'error'})
                    }
                    this.loading = false;
                }, err => {
                    this.msjShow({txt: 'Error al realizar validacion de edición de precio', tipo: 'error'});
                    this.loading = true;
                })
            },
            precioConfirma() {
                this.loading = true;
                this.precioEdicionConfirma({
                    item: this.item,
                    precio: this.precio,
                    producto: this.producto
                }, r => {
                    if (r.valida === true) {
                        this.actualizaValor();
                    } else {
                        this.msjShow({txt: r.msj, tipo: 'error'})
                    }
                    this.loading = false;
                }, err => {
                    this.msjShow({txt: 'Error al realizar validacion de edición de precio', tipo: 'error'});
                    this.loading = false;
                })
            },
            cerrar() {
                this.menu = false;
                this.valueNuevo = '';
                this.observar = false;
                this.obs = '';
                this.porcent = '';
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/DescuentoField.vue